/**
 * 站外链接统一配置
 *
 * Token管理 / 人员管理 / 安装SKILL 等系统级页面已迁移至 shouqian 主站，
 * 各处以新标签页打开。集中定义避免多处散落的 SSO_HOME_URL 重复常量。
 */

// shouqian 主站地址（可经 REACT_APP_SSO_HOME_URL 覆盖，如本地联调指向 localhost）
export const SSO_HOME_URL = process.env.REACT_APP_SSO_HOME_URL || 'https://www.healthsafety.cn';

/** Token 管理（主站 hash 路由） */
export const TOKEN_MANAGEMENT_URL = `${SSO_HOME_URL}/#/tokens`;

/** 人员管理（主站 hash 路由，仅管理员可达） */
export const USER_MANAGEMENT_URL = `${SSO_HOME_URL}/#/users`;

/** 安装SKILL 引导页（主站 hash 路由） */
export const SKILL_URL = `${SSO_HOME_URL}/#/skill`;

/** 新标签页打开站外页面 */
export const openExternal = (url: string) => {
  window.open(url, '_blank');
};
